module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Closed Trails":"Pistes fermées","Legend":"Légende"}}')
  delete Component.options._Ctor
}
